import { grafanaLogout } from "./grafanaLogout";
import userManager from "../auth/userManager";

// Ends the session by clearing local state immediately,
// and firing best-effort background requests to log out of Grafana
// and the OIDC Provider. Does not navigate the browser away.
export async function performLogout() {
  // Clear local OIDC state first (instantly shows login page)
  await userManager.removeUser();

  // Perform background logouts concurrently
  const oidcLogoutUrl = userManager.settings.authority + "/end-session/";
  
  await Promise.allSettled([
    grafanaLogout(),
    fetch(oidcLogoutUrl, {
      method: 'GET',
      credentials: 'include',
    }).catch(console.error)
  ]);
}
